'use client'
import './fisherContent.scss'

import React, { useEffect, useState } from 'react'

import spriteUrl from '@/src/shared/images/v3/css_sprites_compr.png'
import flashUrl from '@/src/shared/images/v3/flash.png'

import { spriteData } from './data'

const FisherContent = () => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const spriteImg = new Image()
    const flashImg = new Image()
    let loadedCount = 0

    const handleLoad = () => {
      loadedCount += 1
      if (loadedCount === 2) setIsLoaded(true)
    }

    spriteImg.onload = handleLoad
    flashImg.onload = handleLoad
    spriteImg.src = spriteUrl.src
    flashImg.src = flashUrl.src
  }, [])

  useEffect(() => {
    if (!isLoaded) return

    const scene = document.querySelector('.sprite-scene')
    const eventType = 'scroll'
    if (!scene) return

    const layers = scene.querySelectorAll('.layer') as NodeListOf<HTMLElement>
    let ticking = false

    const handleScroll = () => {
      const sceneTop = scene.getBoundingClientRect().top + window.scrollY
      const sceneHeight = scene.clientHeight
      const scrollY = window.scrollY
      const progress = Math.min(Math.max((scrollY - sceneTop) / sceneHeight, 0), 1)

      layers.forEach((el) => {
        const speed = parseFloat(el.dataset.speed || '1')
        const effect = el.dataset.effect || 'translate'
        const dx = parseFloat(el.dataset.dx || '0')
        const dy = parseFloat(el.dataset.dy || '0')

        if (effect === 'translate') {
          const x = dx * progress * speed
          const y = dy * progress * speed
          el.style.transform = `translate(${x}px, ${y}px)`
        } else if (effect === 'scale') {
          const scale = 1 + progress * speed * 0.3
          el.style.transform = `scale(${scale})`
        } else {
          el.style.transform = ''
        }
      })

      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(handleScroll)
        ticking = true
      }
    }

    window.addEventListener(eventType, onScroll)
    handleScroll()

    return () => window.removeEventListener(eventType, onScroll)
  }, [isLoaded])

  return (
    <div className="fisher-wrapper">
      {isLoaded && (
        <div className="sprite-scene-wrapper">
          <div className="sprite-scene">
            <div className="fisher-gradient"></div>
            <div className="heading-gradient"></div>
            {spriteData.map((sprite, i) => {
              const commonStyle: React.CSSProperties = {
                width: sprite.w,
                height: sprite.h,
                backgroundImage: `url('${spriteUrl.src}')`,
                backgroundPosition: `-${sprite.x}px -${sprite.y}px`,
                backgroundRepeat: 'no-repeat',
                willChange: 'transform',
                position: 'absolute',
                top: sprite.top ?? 0,
                left: sprite.left ?? 0,
              }

              const dataAttrs = {
                'data-speed': sprite.speed ?? 1,
                'data-effect': sprite.effect ?? 'translate',
                'data-dx': sprite.dx ?? 0,
                'data-dy': sprite.dy ?? 0,
              }

              return (
                <div
                  key={i}
                  className={`sprite ${sprite.class} layer`}
                  {...dataAttrs}
                  style={commonStyle}
                />
              )
            })}

            <div
              className="sprite fisherman"
              data-speed={1}
              data-effect="none"
              style={{
                width: 561,
                height: 727,
                backgroundImage: `url('${spriteUrl.src}')`,
                backgroundPosition: `-2974px -88px`,
                backgroundRepeat: 'no-repeat',
                position: 'absolute',
                top: 70,
                left: 640,
              }}
            />
            <div
              className="flash-rotated"
              data-speed={1}
              data-effect="none"
              style={{
                width: 121,
                height: 121,
                backgroundImage: `url('${flashUrl.src}')`,
                backgroundRepeat: 'no-repeat',
                position: 'absolute',
                top: 110,
                left: 680,
              }}
            />
            <div
              className="flash-rotated"
              data-speed={1}
              data-effect="none"
              style={{
                width: 121,
                height: 121,
                backgroundImage: `url('${flashUrl.src}')`,
                backgroundRepeat: 'no-repeat',
                position: 'absolute',
                top: 155,
                left: 1090,
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default FisherContent
